import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Branch } from '../../agatextscreens/accounting/branch';
import { Http, Headers, URLSearchParams } from '@angular/http';
import { Configuration } from '../../app.constants';
import { AuthenticationService } from './authentication.service';
import { Cheque } from '../../agatextscreens/accounting/cheque';
import { Bank } from '../../agatextscreens/accounting/bank';
import { Invoice } from '../../agatextscreens/accounting/invoice';

@Injectable()
export class ChequeService {
  private _chequeApiUrl: string = this._configuration.apiUrl + "/v2/cheque";

  constructor(private _http: Http,
    private _configuration: Configuration,
    public _authService: AuthenticationService) { }

  getCheques(): Observable<Cheque[]> {
    let h = this._authService.getHeaders();

    return this._http.get(this._chequeApiUrl, { headers: h, search: null }).map(
      response => {
        let body = response.json();
        let chk: Cheque[];

        if (body['cheques'] == null || !Array.isArray(body['cheques'])) {
          chk = [];
        } else {
          chk = body['cheques'];
        }

        return chk;
      }
    );
  }

  createCheque(customer_id, branch_id, amount, maturity_date, endorsement, cheque_number, invoice_list: { id: string, amount: number }[]): Observable<any> {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._chequeApiUrl,
      {
        // creating cheque in DB
        customer_id: customer_id,
        amount: amount,
        maturity_date: maturity_date,
        endorsement: endorsement,
        cheque_number: cheque_number,
        branch_id: branch_id,
        invoice_list: invoice_list
      }, { headers: h, search: s }).map(response => response.json());
  }

  getRelatedInvoices(cheque_id: string): Observable<any[]> {
    let h = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    s.append('related', 'true');
    s.append('cheque_id', cheque_id);

    return this._http.get(this._chequeApiUrl, { headers: h, search: s }).map(
      response => {
        let body = response.json();
        let inv: any[];

        if (body['invoices'] == null || !Array.isArray(body['invoices'])) {
          inv = [];
        } else {
          inv = body['invoices'];
        }

        return inv;
      }
    );
  }

  settleCheque(cheque_id, effective_date) {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.put(this._chequeApiUrl, { id: cheque_id, settled: true, settled_on: effective_date }, { headers: h, search: s }).map(response => response.json());
  }

  /*depositToBank(cheques: Cheque[], bank_id: number): any {
    let h: Headers = this._authService.getHeaders();
    let s: URLSearchParams = new URLSearchParams();

    return this._http.post(this._chequeApiUrl, { cheques: cheques, bank_id: bank_id }, { headers: h, search: s }).map(response => response.json());
  }*/

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/shared/services/cheque.service.ts